import styles from './PartnerCardSkeleton.module.css';

export default function PartnerCardSkeleton() {
  return (
    <li className={styles.card}>
      <div className={styles.logoWrapper}>
        <div className={styles.logoSkeleton} />
      </div>
      <div className={styles.content}>
        <div className={styles.nameSkeleton} />
        <div className={styles.descriptionSkeleton}>
          <div className={styles.line} />
          <div className={styles.line} />
          <div className={styles.line} />
        </div>
      </div>
    </li>
  );
}
